(function () {
    'use strict';

    function setupMobileMenu() {
        const mobileMenuButton = document.getElementById("mobile-menu-button");
        const closeMenuButton = document.getElementById("close-menu-button");
        const mobileMenu = document.getElementById("mobile-menu");

        function toggleMobileMenu() {
            mobileMenu.classList.toggle("translate-x-full");
            mobileMenu.classList.toggle("translate-x-0");
        }

        if (mobileMenuButton) mobileMenuButton.addEventListener("click", toggleMobileMenu);
        if (closeMenuButton) closeMenuButton.addEventListener("click", toggleMobileMenu);
    }

    function setupSearchForm() {
        const selects = ["category", "make", "yearFrom", "yearTo"];
        const searchForm = document.getElementById("searchForm");
        const searchButton = document.getElementById("searchButton");

        fetch("/api/qsdata", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({})
        })
            .then(res => res.json())
            .then(data => populateAllSelects(data));

        selects.forEach(id => {
            const el = document.getElementById(id);
            if (el) el.addEventListener("change", handleSelectionChange);
        });

        if(searchForm) searchForm.addEventListener("submit", (e) => {
            e.preventDefault();
            const url = searchButton.getAttribute("data-url");
            if (url) window.location.href = url;
        });

        function handleSelectionChange() {
            const payload = getFormValues();

            fetch("/api/qsdata", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            })
                .then(res => res.json())
                .then(data => populateAllSelects(data))
                .catch(err => console.error("Dropdown update failed:", err));
        }

        function getFormValues() {
            return {
                idCategory: document.getElementById("category") ? document.getElementById("category").value : null,
                idMake: document.getElementById("make") ? document.getElementById("make").value : null,
                yearFrom: document.getElementById("yearFrom") ? document.getElementById("yearFrom").value : null,
                yearTo: document.getElementById("yearTo") ? document.getElementById("yearTo").value : null,
            };
        }

        function populateAllSelects(data) {
            clearAndFill("category", data.categories, "idCategory", "name", "count");
            clearAndFill("make", data.makes, "idMake", "name", "count");
            clearAndFill("yearFrom", data.yearsFrom, "value", "displayValue", "count");
            clearAndFill("yearTo", data.yearsTo, "value", "displayValue", "count");

            if(searchButton) searchButton.setAttribute("data-url", data.url || "/boats-for-sale/");
        }

        function clearAndFill(id, values, valueKey, labelKey, countKey) {
            const select = document.getElementById(id);
            const currentValue = select ? select.value || "" : "";
            select.innerHTML = '<option value="">All</option>';

            values.forEach(item => {
                const option = document.createElement("option");
                option.value = item[valueKey];
                option.textContent = labelKey === "displayValue"
                    ? item[labelKey]
                    : `${item[labelKey]} (${item[countKey]})`;
                select.appendChild(option);
            });

            if (currentValue && values.find(v => String(v[valueKey]) === currentValue)) {
                select.value = currentValue;
            }
        }
    }

    function resizeImages() {
        document.querySelectorAll(".image-container img").forEach(img => {
            img.style.objectFit = "cover";
            img.style.width = "100%";
            img.style.height = "100%";
        });
    }

    function loadRecommendedAds() {
        fetch("/api/search/indexads")
            .then(res => res.json())
            .then(boats => renderRecommendedAds(boats))
            .catch(err => console.error("Failed to load recommended ads", err));
    }

    function renderRecommendedAds(boats) {
        const grid = document.getElementById("adsGrid");
        if (!grid) return;

        boats.forEach(boat => {
            const card = document.createElement("a");
            card.href = boat.detailUrl;
            card.className = "group relative flex flex-col bg-white/90 backdrop-blur rounded-2xl border border-slate-100 shadow-lg overflow-hidden transition duration-200 hover:-translate-y-1 hover:shadow-2xl";

            card.innerHTML =
                '<div class="relative overflow-hidden">' +
                '<div class="image-container">' +
                '<img src="' + boat.defaultImageUrl + '" alt="' + boat.title + '">' +
                '</div>' +
                '<span class="absolute bottom-3 left-3 inline-flex items-center gap-2 bg-black/60 text-white text-xs px-3 py-1 rounded-full">' +
                '<span class="inline-block w-2 h-2 rounded-full bg-emerald-400"></span>' +
                'Verified listing' +
                '</span>' +
                '</div>' +
                '<div class="p-4 flex flex-col gap-3 flex-1">' +
                '<div>' +
                '<p class="text-xs uppercase tracking-[0.2em] text-primary mb-2">' + (boat.category || 'Multi-class') + '</p>' +
                '<h3 class="text-lg font-semibold text-textPrimary leading-snug">' + boat.title + '</h3>' +
                '</div>' +
                '<div class="flex items-center text-sm text-textSecondary gap-2">' +
                '<svg class="w-4 h-4 text-secondary" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round">' +
                '<path d="M21 10c0 6-9 13-9 13S3 16 3 10a9 9 0 0118 0z" />' +
                '<circle cx="12" cy="10" r="3" />' +
                '</svg>' +
                (boat.location || 'Nationwide') +
                '</div>' +
                '<div class="flex flex-wrap gap-2 text-xs text-textSecondary">' +
                (boat.displayLength ? '<span class="spec-chip">' + boat.displayLength + '</span>' : '') +
                (boat.year ? '<span class="spec-chip">' + boat.year + '</span>' : '') +
                (boat.engineFuel ? '<span class="spec-chip">' + boat.engineFuel + '</span>' : '') +
                '</div>' +
                '<div class="flex items-center justify-between pt-2 border-t border-slate-100">' +
                '<p class="text-2xl font-semibold text-primary">' + boat.displayPrice + '</p>' +
                '<span class="text-xs font-semibold text-emerald-600 bg-emerald-50 px-3 py-1 rounded-full">' +
                'Hot lead volume' +
                '</span>' +
                '</div>' +
                '</div>';
            grid.appendChild(card);
        });
        resizeImages();
    }

    document.addEventListener("DOMContentLoaded", () => {
        setupMobileMenu();
        setupSearchForm();
        loadRecommendedAds();
    });

}());
